<template>
  <div>
    <div class="custom-card-header">
      <!-- <div class="filterButtonPosition">
        <div class="display-flex">
          <f7-button outline @click="newAlert">
            {{ $t('alert.new') }}
          </f7-button>
          <f7-button
            fill
            class="whiteFontColor button-filter"
            panel-toggle="right"
          >
            <span class="ic-filter"></span> {{ $t('filter') }}
          </f7-button>
        </div>
      </div> -->
    </div>

    <DxDataGrid
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="{
        paging: true,
        filtering: true,
        sorting: false,
      }"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      class="custom-grid custom-alerts-paramsTable"
      @contentReady="init"
      @focused-row-changed="focusedRowChanged"
      @toolbar-preparing="onToolbarPreparing($event)"
    >
      <DxScrolling mode="standard" />
      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="alertsParamsTable"
      />
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <DxSearchPanel
        :visible="true"
        :width="300"
        :placeholder="$t('search')"
      />

      <DxColumn
        data-field="atc"
        :caption="$t('alert.area')"
        alignment="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="sample_type"
        :caption="$t('agronomySample.summary.sampleType')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="farm"
        :caption="$t('foodSamples.samplingSite')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="parcel"
        :caption="$t('environmentSamples.samplingPoint')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="created_at"
        :caption="$t('alert.creationDate')"
        alignment="left"
        data-type="date"
        :format="$helpers.getDateFormat(company) + ' HH:mm:ss'"
        sort-order="desc"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="updated_at"
        :caption="$t('alert.modificationDate')"
        alignment="left"
        data-type="date"
        :format="$helpers.getDateFormat(company) + ' HH:mm:ss'"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="parameters"
        :caption="$t('alert.parameters')"
        alignment="left"
        :allow-header-filtering="false"
        cell-template="cellTemplateParams"
      />
      <DxColumn
        data-field=""
        :caption="$t('status')"
        alignment="left"
        :fixed="true"
        fixed-position="right"
        :allow-header-filtering="false"
        cell-template="cellTemplateStatus"
      />
      <DxColumn
        :buttons="editButtons"
        :fixed="true"
        fixed-position="right"
        type="buttons"
        width="90"
      />

      <template #cellTemplateParams="{ data }">
        <div style="min-width: 100px">
          {{
            data.value.flatMap((param) => param.parameter).toString()
          }}
        </div>
      </template>

      <template #cellTemplateStatus="{ data }">
        <div>
          <DxSwitch
            :value="data.data.is_active"
            @valueChanged="
              () => {
                updateState(
                  'status',
                  {
                    newState: !data.data.is_active,
                    id: data.data.id,
                  },
                  data
                );
              }
            "
          />
        </div>
      </template>
    </DxDataGrid>

    <NewAlertPopup
      v-if="showNewAlertPopup"
      :edit-data="editData"
      :params="params"
    />
  </div>
</template>
<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
} from 'devextreme-vue/data-grid';

import { DxSwitch } from 'devextreme-vue/switch';
import { mapActions, mapState } from 'vuex';

import NewAlertPopup from '@/components/Alerts/Settings/NewAlertPopup/Params/index.vue';
import EventBus from '@/services/event-bus';
import notify from 'devextreme/ui/notify';
import Helpers from '@/js/helpers';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import iconTrash from '@/static/icons/ic_trash_new.svg';
import iconEdit from '@/static/icons/ic_edit_new.svg';
import iconCopy from '@/static/icons/ic_copy_new.svg';

export default {
  name: 'ParamsTable',
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    DxSwitch,
    NewAlertPopup,
  },
  props: {
    store: {
      type: Object,
      default: () => {},
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      editButtons: [
        {
          icon: iconCopy,
          cssClass: 'grid-button-icon',
          onClick: this.duplicateConfirm,
        },
        {
          icon: iconEdit,
          cssClass: 'grid-button-icon ic-edit-new',
          onClick: this.editAlert,
        },
        {
          icon: iconTrash,
          cssClass: 'grid-button-icon',
          onClick: this.deleteConfirm,
        },
      ],
      editData: {},
      changedFocused: false,
      autoFocus: !Helpers.isEmptyObject(this.params),
    };
  },
  computed: {
    ...mapState('contact', ['company']),
    ...mapState('alerts', ['showNewAlertPopup']),
    ...mapState('alertsParams', ['focusedRowKey']),
  },
  created() {
    localStorage.removeItem('alertsParamsTable');
  },
  methods: {
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-simple-toolbar',
      };
      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'before';
        }
      });

      // Añadir el selector de agrupaciones
      toolbarItems.push({
        name: 'Filtros',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('filter'),
          icon: '././static/icons/ic_filter.svg',
          width: 115,
          elementAttr: {
            class: 'btn-filtrar',
          },
          onClick: () => {
            this.$f7.panel.open('right');
          },
        },
      });

      // Boton para Nueva alerta
      toolbarItems.push({
        location: 'after',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('alert.new'),
          elementAttr: {
            class: 'botones-registrar',
          },
          onClick: () => {
            this.newAlert();
          },
        },
      });

      // Boton por estado
      toolbarItems.push({
        name: 'Por estado',
        location: 'after',
        widget: 'dxSelectBox',
        locateInMenu: 'never',
        visible: false,
        options: {
          placeholder: this.$t('byStatus'),
          elementAttr: {
            class: 'btn-estado',
          },
          dataSource: '',
          displayExpr: '',
          valueExpr: '', // o según el identificador
          dropDownButtonTemplate() {
            return `
          <div class="dropdown-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 14.677C11.8795 14.677 11.7673 14.6577 11.6635 14.6192C11.5597 14.5807 11.4609 14.5147 11.3673 14.4212L6.873 9.927C6.73467 9.7885 6.66384 9.61441 6.6605 9.40475C6.65734 9.19525 6.72817 9.018 6.873 8.873C7.018 8.72816 7.19367 8.65575 7.4 8.65575C7.60634 8.65575 7.782 8.72816 7.927 8.873L12 12.9462L16.073 8.873C16.2115 8.73466 16.3856 8.66383 16.5953 8.6605C16.8048 8.65733 16.982 8.72816 17.127 8.873C17.2718 9.018 17.3443 9.19366 17.3443 9.4C17.3443 9.60633 17.2718 9.782 17.127 9.927L12.6328 14.4212C12.5391 14.5147 12.4403 14.5807 12.3365 14.6192C12.2327 14.6577 12.1205 14.677 12 14.677Z" fill="#00346A"/>
            </svg>
          </div>
      `;
          },
        },
      });
    },
    init(e) {
      e.component.option('focusedRowKey', this.focusedRowKey);
      this.changedFocused = true;
    },
    focusedRowChanged(row) {
      if (!row.row) return;

      if (this.changedFocused) {
        if (Helpers.isEmptyObject(this.params)) {
          this.setFocusedRowKey(row.row.data.id);
        }
      }
    },
    async updateState(type, data, grid) {
      const updatedRow = await this.store.update(type, data);

      grid.row.data.is_active = updatedRow.is_active;
      grid.component.repaintRows(grid.rowIndex);
    },
    newAlert() {
      this.editData = {};
      this.setShowNewAlertPopup(true);
    },
    editAlert(e) {
      this.editData.isEditing = true;
      this.editData.data = {};
      this.editData.data.id = e.row.data.id;
      this.editData.data.area = e.row.data.atc;
      this.editData.data.sampleType = e.row.data.sample_type;
      this.editData.data.sampleTypeId = e.row.data.sample_type_id;
      this.editData.data.farm = e.row.data.farm;
      this.editData.data.parcel = e.row.data.parcel;
      this.editData.data.parameters = e.row.data.parameters;
      this.editData.data.study = e.row.data.study || '';
      this.editData.data.sendingNotifications =
        e.row.data.sending_notifications || false;

      this.setShowNewAlertPopup(true);
    },
    applyFramework7DialogTexts() {
      if (!this.$f7) return;

      this.$f7.params.dialog.buttonCancel = this.$t('cancel');
      this.$f7.params.dialog.buttonOk = this.$t('samplesRegister.ok');
    },
    deleteConfirm(e) {
      this.applyFramework7DialogTexts();
      this.$f7.dialog.confirm(
        `${this.$t('alert.deleteConfirm')}`,
        async () => {
          const { id } = e.row.data;

          try {
            notify(
              {
                message: this.$t('alert.deleting'),
                width: 450,
              },
              'info',
              2000
            );

            await this.deleteAlert(id);

            notify(
              {
                closeOnClick: true,
                message: this.$t('alert.deleted'),
                width: 450,
              },
              'success',
              2000
            );
            EventBus.$emit('newParamAlert', this.params);
            this.$f7.dialog.close();
          } catch (error) {
            this.$notifyDX(
              {
                message: this.$t(
                  this.$helpers.getFilteredErrorMessage(
                    JSON.parse(error.message).error
                  )
                ),
                width: 550,
              },
              'error',
              NOTIFY_TIME_LONG
            );
          }
        }
      );
    },
    duplicateConfirm(e) {
      const rowData = e.row.data;
      const data = {
        parameters: rowData.parameters,
        farm: rowData.farm,
        sampleTypeId: rowData.sample_type_id,
        parcel: rowData.parcel,
        atc: rowData.atc,
        sampleType: rowData.sample_type,
        isActive: rowData.is_active,
        study: rowData.study,
        sendingNotifications: rowData.sending_notifications,
      };

      this.applyFramework7DialogTexts();
      this.$f7.dialog.confirm(
        `${this.$t('alert.duplicateConfirm')}`,
        async () => {
          try {
            notify(
              {
                message: this.$t('alert.duplicating'),
                width: 450,
              },
              'info',
              2000
            );
            await this.duplicateAlert(data);
            notify(
              {
                closeOnClick: true,
                message: this.$t('alert.duplicated'),
                width: 450,
              },
              'success',
              2000
            );
            EventBus.$emit('newParamAlert', this.params);
            this.$f7.dialog.close();
          } catch (error) {
            this.$notifyDX(
              {
                message: this.$t(
                  this.$helpers.getFilteredErrorMessage(
                    JSON.parse(error.message).error
                  )
                ),
                width: 550,
              },
              'error',
              NOTIFY_TIME_LONG
            );
          }
        }
      );
    },
    ...mapActions('alerts', ['setShowNewAlertPopup']),
    ...mapActions('alertsParams', [
      'deleteAlert',
      'duplicateAlert',
      'setFocusedRowKey',
    ]),
  },
};
</script>
<style lang="scss">
@import './paramsTable.styles.scss';
</style>
